export default "__VITE_ASSET__CvANBwT0__"